import { render, staticRenderFns } from "./ClinicDashboard.vue?vue&type=template&id=3e441a87&"
import script from "./ClinicDashboard.vue?vue&type=script&lang=js&"
export * from "./ClinicDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ClinicDashboard.vue?vue&type=style&index=0&id=3e441a87&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports